import { useIsTreatmentVariantByUser } from "../../utils";

export const PAWS_BRAINTREE_CC_EXPERIMENT_KEY = "tc-1046-use-pawsbraintreecc";

export const usePawsBraintreeCC = () =>
  useIsTreatmentVariantByUser(PAWS_BRAINTREE_CC_EXPERIMENT_KEY);
